import { render, staticRenderFns } from "./SurfaceNavBookmarkMenuRow.vue?vue&type=template&id=1ce44453&"
import script from "./SurfaceNavBookmarkMenuRow.vue?vue&type=script&lang=ts&"
export * from "./SurfaceNavBookmarkMenuRow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports